<app-upload-files *ngIf="allowUpload" [uploadFilesSettings]="uploadFilesSettings"
    (uploadedEvent)="newUploadedItem($event)">
</app-upload-files>

<app-loading-panel [isLoading]="isLoading"></app-loading-panel>

<div fxLayout="row" class="document-header-cell">

    <div *ngIf="documentInfos$|async;let documentInfos" fxFlex="column">

        <div fxLayoutAlign="center center" *ngIf="documentInfos?.length === 0 && showIfEmpty" class="form-block" >
            <h2 >{{'mobile-center.noDocuments' | translate}} </h2>
        </div>

        <div *ngIf="documentInfos?.length > 0" fxFlex="column" class="form-block">
            <div *ngFor="let documentInfo of documentInfos" class="bottom-border">
                <div fxLayout="row" fxLayoutGap="10">
                    <div fxFlex="40px" class="pointer">
                        <img role="none" [src]="documentInfo.fileExtension | fileTypeIcon" [width]='32'
                            (click)="showContent(documentInfo)" alt="file-type" />
                    </div>
                    <div fxLayout="column">
                        <strong class="small-bold-info">
                            {{documentInfo.documentKindId | staticDictionaryCaption:'documentKind' |async }}
                        </strong>
                        <span class="small-info" *ngIf="documentInfo.fileSize > 0"> {{documentInfo.name}}
                            ({{documentInfo.fileSize |
                            filesize}})</span>
                        <span class="small-info">
                            {{documentInfo.description}}
                        </span>
                        <span class="small-info">
                            {{'mobile-center.storeDateShort' | translate}} : {{documentInfo.timestamp | date:
                            'yyyy-MM-dd HH:mm:ss'}}
                            ({{documentInfo.createdBy}})
                        </span>
                    </div>
                    <div fxFlex="40px" *ngIf="!documentInfo.isSigned && isSignable(documentInfo.documentKindId) && !documentInfo.isArchived">
                        <button kendoButton (click)="openToSign(documentInfo)" [icon]="'signature'" [primary]="true"
                            [disabled]="disableSign">
                        </button>
                    </div>
                    <div fxFlex="40px" *ngIf="documentInfo.isSigned">
                        <kendo-icon size="xxlarge" [name]="'signature'" themeColor="success"
                            title="{{'claims-center.claimDocumentation.documentSigned' | translate}}"></kendo-icon>
                    </div>

                    <div fxFlex="40px" *ngIf="documentInfo.emailWithSignedDocumentSentTimestamp">
                        <kendo-icon size="xxlarge" [name]="'email'" themeColor="success"
                        title="{{'claims-center.claimDocumentation.documentSentByEmail' | translate}} {{ documentInfo.emailWithSignedDocumentSentTimestamp | date:'yyyy-MM-dd HH:mm'}}"></kendo-icon>
                    </div>

                    <div fxFlex="40px" *ngIf="documentInfo.isSigned && canBeSentByEmail(documentInfo.documentKindId) && !documentInfo.isArchived" >
                        <button kendoButton (click)="sendSignedDocumentByEmail(documentInfo)" [icon]="'email'" [primary]="true">
                        </button>
                    </div>

                    <div fxLayout="row" fxLayoutAlign="center center" *ngIf="documentInfo.isArchived">
                        <strong>{{'claims-center.claimDocumentation.documentIsAlreadyArchived' | translate}}</strong>
                    </div>

                </div>
            </div>
        </div>
    </div>

</div>

<div kendoDialogContainer #showDocumentsMultiple2Dialog></div>